import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { priceFormat } from '../../../../util';
import { oneBtnPopupCreator, twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';
import * as Styled from '../SimplrOrder.styles';
import Loading from '../../../LoadingComponent/LoadingComponent';
import { Button } from '../../../common/buttonsComponents';
import { connect } from 'react-redux';
import { setSelectedTask } from '../../../../actions/tools/OrdersSearchActions';
import { cancelSimplrOrder } from '../../../../actions/tools/SimplrOrderActions';
import { addNoteToTicket } from '../../../../actions';
import {
  getSelectedOrderFromOrdersSearch,
  extractSelectedInboxTab,
  extractSelectedTicketFromState,
  isSpecialist,
} from '../../../../extractFromState';
import { selectSelectedToolDomains } from '../../../../selectors/tools';
import NumberPillInput from '../../../controls/NumberPillInput/NumberPillInput';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { showErrorPopup } from '../../../popups/ErrorPopup/ErrorPopup';
import BigNumber from 'bignumber.js';
import {
  CancelOrderButton,
  Divider,
  CancelStep,
  StepTitle,
  Subtext,
  ItemRow,
  Checkbox,
  RowContent,
  TrackingContent,
  ItemDetail,
  RefundCommentTextarea,
  FlexPlaceholder,
  OrderSummaryBox,
  OrderSummaryHeader,
  OrderSummaryInfo,
  OrderSubtotalInfo,
} from './SimplrCancelOrder.styles';
import { handleError } from 'services/ErrorService/ErrorService';

const DESCRIPTION_WITH_CANCELABLE = `The order
 has not shipped, but you can cancel the whole order.`;
const DESCRIPTION_ITEMS_SHIPPED = `One or more items have been shipped, so you cannot cancel items in this order but you can issue refund.`;
const DESCRIPTION_CLOSED = `The order were already cancelled.`;
const DESCRIPTION_REFUNDED = `All refundable items in this order were already cancelled.`;

class SimplrCancelOrder extends Component {
  static propTypes = {
    selectedOrder: PropTypes.object.isRequired,
    selectedTicket: PropTypes.object,
    setSelectedTask: PropTypes.func,
    selectedToolDomains: PropTypes.object,
    isSpecialist: PropTypes.bool,
  };

  static defaultProps = {
    setSelectedTask: () => {},
  };

  get simplrRefundDetails() {
    const selectedOrder = this.props.selectedOrder;

    return selectedOrder && selectedOrder.simplrRefundDetails ? selectedOrder.simplrRefundDetails : [];
  }

  get isSimplrRefundDetailsExist() {
    return !!this.simplrRefundDetails.length;
  }

  get hasRefundableItems() {
    return !!this.state.refundableItems.length;
  }

  async componentDidMount() {
    // TODO: create an action for fetching OrderDetails
    const selectedOrder = this.props.selectedOrder;
    const shippedItems = (selectedOrder['orderItems'] || []).filter((item) => item['itemShippingStatus'] === 'SHIPPED');

    const actualRefundableItems = (selectedOrder.orderItems || [])
      .map((item) => {
        const refundedItem = this.simplrRefundDetails.find((refunded) => refunded.itemId === item.itemId);

        return {
          itemId: item.itemId,
          shipmentId: item.shipmentId,
          itemName: item.itemName,
          paidItemUnitPrice: item.paidItemUnitPrice,
          paidItemUnitTax: item.paidItemUnitTax,
          paidItemTotalPrice: item.paidItemTotalPrice,
          qty: refundedItem ? item.itemQuantity - refundedItem.quantity : item.itemQuantity,
        };
      })
      .filter((item) => item.qty > 0);

    const selectedItems = {};
    for (let refundableItem of actualRefundableItems) {
      selectedItems[refundableItem.itemId] = {
        qty: refundableItem.qty,
        active: true,
      };
    }
    const shipments = selectedOrder.shipment || [];
    let shippingCost = 0.0,
      shippingTax = 0.0;
    for (const shipment of shipments) {
      shippingCost += shipment.shipCost;
      shippingTax += shipment.shipTax;
    }
    const status = selectedOrder['orderStatus'];
    this.setState({
      refundableItems: actualRefundableItems,
      shippedItems,
      selectedItems,
      status,
      shippingCost,
      shippingTax,
      isCancelOrderItemsRequesting: false,
    });
  }

  state = {
    status: '',
    shippingCost: 0.0,
    shippingTax: 0.0,
    currencyCode: 'USD',
    refundableItems: [],
    shippedItems: [],
    selectedItems: {},
    reasonComment: '',
    reasonError: false,
    isCancelRequesting: false,
    isCancelOrderItemsRequesting: true,
    isPolicyAccepted: false,
  };

  get orderId() {
    return this.props.selectedOrder.orderId;
  }

  get isPolicyAccepted() {
    return this.state.isPolicyAccepted;
  }

  get isSpecialist() {
    return this.props.isSpecialist;
  }

  // ------------
  // Step 1
  // ------------

  get isAllItemsSelected() {
    try {
      let result = true;
      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (selectedItem.active === false) {
          result = false;
        }
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return false;
    }
  }

  handleSelectAll = () => {
    const selectedItems = cloneDeep(this.state.selectedItems);

    if (this.isAllItemsSelected) {
      for (let itemId of Object.keys(selectedItems)) {
        selectedItems[itemId].active = false;
      }
    } else {
      for (let item of this.state.refundableItems) {
        selectedItems[item.itemId].qty = item.qty;
        selectedItems[item.itemId].active = true;
      }
    }

    this.setState({ selectedItems });
  };

  handleSelectItem = (itemId) => {
    const selectedItems = cloneDeep(this.state.selectedItems);

    selectedItems[itemId].active = !selectedItems[itemId].active;

    this.setState({ selectedItems });
  };

  handleItemQtyChange = (itemId, newQty) => {
    const selectedItems = cloneDeep(this.state.selectedItems);

    selectedItems[itemId].qty = newQty;
    if (BigNumber(newQty).isEqualTo(BigNumber(0))) {
      selectedItems[itemId].active = !selectedItems[itemId].active;
    }
    this.setState({ selectedItems });
  };

  // ------------
  // Step 2
  // ------------

  handlerTextInputChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  // ------------
  // Totals
  // ------------

  get selectedQty() {
    try {
      let result = 0;

      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        const qty = selectedItem.active ? selectedItem.qty : 0;

        result += qty;
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return 0;
    }
  }

  get subtotal() {
    try {
      let result = 0.0;
      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (!selectedItem) {
          throw new Error('item not selected');
        }
        const itemSubtotal = selectedItem.active ? item['paidItemUnitPrice'] * selectedItem.qty : 0;

        result += itemSubtotal;
      }

      return result;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return 0;
    }
  }

  get tax() {
    try {
      let result = 0.0;

      for (let item of this.state.refundableItems) {
        const selectedItem = get(this.state.selectedItems, item.itemId, null);
        if (!selectedItem) {
          throw new Error('item not selected');
        }
        const qty = selectedItem.active ? selectedItem.qty : 0;

        result += item['paidItemUnitTax'] * qty;
      }

      return result + this.state.shippingTax;
    } catch (e) {
      showErrorPopup(`The selected item was not found`, 'Oops!');

      return 0;
    }
  }

  get shipping() {
    let totalRefundable = 0;
    for (let item of this.state.refundableItems) {
      totalRefundable += item['paidItemTotalPrice'];
    }
    if (this.state.shippedItems.length || totalRefundable === 0) {
      return 0;
    }

    return this.isAllItemsSelected && this.state.shippingCost ? this.state.shippingCost : 0;
  }

  get totalRefund() {
    return this.subtotal + this.tax + this.shipping;
  }

  // ------------
  // Commons
  // ------------

  get isOrderCancelled() {
    return this.state.status === 'CANCELLED';
  }

  get hasShippedItems() {
    return this.state.status !== 'CANCELLED' && !!this.state.shippedItems.length;
  }

  get placeholderText() {
    // TODO: Make this if string readable
    if (this.state.status === 'CANCELLED') {
      return DESCRIPTION_CLOSED;
    }

    if (!this.state.refundableItems.length) {
      return DESCRIPTION_REFUNDED;
    }

    if (this.hasShippedItems) {
      return DESCRIPTION_ITEMS_SHIPPED;
    }

    return DESCRIPTION_WITH_CANCELABLE;
  }

  /**
   * Formatting price with currency sign
   * @example 12 -> $12.00
   * @param {string|number} value
   * @return {string}
   */
  priceFormat = (value) => priceFormat(value, this.state.currencyCode);

  handleBackBtnClick = () => {
    this.props.setSelectedTask(null);
  };

  // ------------
  // Refund process
  // ------------

  displayPopupErrorMessage(message = '') {
    return oneBtnPopupCreator({
      content: {
        main: message,
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  }

  handleRefundBtnClick = () => {
    if (this.selectedQty === 0) {
      return this.displayPopupErrorMessage('Please add at least one item');
    }
    if (!this.state.reasonComment) {
      this.setState({ reasonError: true });

      return this.displayPopupErrorMessage('Please add reason for refund');
    }
    this.setState({ reasonError: false });
    twoBtnPopupCreator({
      content: {
        main: 'Are you sure you want to cancel the order?',
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'CANCEL ORDER',
      },
      onConfirm: this.confirmationHandler,
    });
  };

  confirmationHandler = async () => {
    let messageBody = '';
    messageBody += `Cancel note, Order #${this.orderId}.\n`;
    messageBody += `Reason for cancel: ${this.state.reasonComment}\n`;
    messageBody += `Amount refunded: $${parseFloat(this.totalRefund).toFixed(2)}`;

    this.setState({ isCancelRequesting: true });
    const refundItemsIds = this.state.refundableItems.map((item) => item.itemId);

    const payload = {
      orderId: this.orderId,
      orderItemIds: refundItemsIds,
      cancelAction: 'REFUND',
      cancelType: 'FULL',
      domain: this.props.domain,
    };

    const { simplrAccountPtrId } = this.props.selectedTicket;

    try {
      const response = await this.props.cancelSimplrOrder(simplrAccountPtrId, payload);
      if (!response.success) {
        this.handleFailedRefund(response.errorMessage);
      } else {
        if (this.props.selectedInboxTab === 'assigned') {
          await this.props.addNoteToTicket(messageBody, this.props.selectedTicket);
        }
        this.handleSuccessRefund();
      }
    } catch (e) {
      // We have to do this because axios is returning a string that we can't parse directly. It's automatically combining the data object as a string with the error message
      // and we still don't know why - 5/6/2019
      let errorMessage;
      const errorArray = e.message.split('Not Found');
      errorArray.length > 1 ? (errorMessage = JSON.parse(errorArray[1]).errorMessage) : (errorMessage = undefined);
      this.handleFailedRefund(errorMessage);
      handleError({ error: e, customMessage: errorMessage });
    }
  };

  handleSuccessRefund = () => {
    this.setState({ isCancelRequesting: false });

    this.props.setSelectedTask(null);

    oneBtnPopupCreator({
      content: {
        main: `Cancel order successful: Refunded ${parseFloat(this.totalRefund).toFixed(2)}${this.state.currencyCode}`,
        iconPath: '/images/checkmark-green.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  handleFailedRefund = (message = undefined) => {
    this.setState({ isCancelRequesting: false });
    if (message === undefined) {
      oneBtnPopupCreator({
        content: {
          main: 'Cancel order failed',
          iconPath: '/images/error-esclamation.svg',
        },
        btnConfig: 'CLOSE',
      });
    } else {
      oneBtnPopupCreator({
        content: {
          main: `${message}`,
          iconPath: '/images/error-esclamation.svg',
        },
        btnConfig: 'CLOSE',
      });
    }
  };

  // ------------
  // Item attributes
  // ------------
  getItemAttr(item) {
    const { extension } = item;
    const result = extension.reduce((res, elem) => {
      res.push(`${elem.label}: ${elem.value}`);

      return res;
    }, []);

    if (result.length) {
      return `(${result.join(', ')})`;
    }

    return null;
  }

  // ------------
  // Renders
  // ------------

  renderComponent() {
    const refundableItemsJSX = this.state.refundableItems.map((item) => {
      const { itemId, qty, itemName } = item;
      const selectedItem = this.state.selectedItems[itemId];

      return (
        <ItemRow key={itemId}>
          <Checkbox type="checkbox" checked={selectedItem.active} onChange={() => this.handleSelectItem(itemId)} />
          <RowContent>
            <ItemDetail active={selectedItem.active}>
              ({qty}) {itemName}
            </ItemDetail>
            {selectedItem && (
              <NumberPillInput
                qty={selectedItem.qty}
                min={0}
                step={1}
                max={qty}
                onChange={(newQty) => this.handleItemQtyChange(itemId, newQty)}
              />
            )}
          </RowContent>
        </ItemRow>
      );
    });

    const shippedItemsJSX = this.state.shippedItems.map((item) => {
      const itemId = item.itemId;
      const trackingDetails = (
        <ItemRow key={itemId + '-tracking'}>
          <TrackingContent key="content">
            <ItemDetail key="itemDetail" active={false}>
              {'Tracking numbers: ' + item['itemTrackingUrl']}
            </ItemDetail>
          </TrackingContent>
        </ItemRow>
      );

      return (
        <div>
          <ItemRow key={itemId}>
            <RowContent key="content">
              <ItemDetail key="itemDetail" active={false}>
                ({item['itemShippingStatus']}) {item['itemName']}
              </ItemDetail>
            </RowContent>
          </ItemRow>
          {!!item['itemTrackingUrl'] && trackingDetails}
        </div>
      );
    });

    const selectedOrder = this.props.selectedOrder;
    const refundedItemsJSX = this.simplrRefundDetails.map((item) => {
      const { itemId, quantity } = item;
      const orderItem = (selectedOrder.orderItems || []).find((orderItems) => itemId === orderItems.itemId);

      if (!orderItem) {
        return null;
      }

      return (
        <div key={itemId}>
          <ItemRow>
            <RowContent key="content">
              <ItemDetail key="itemDetail" active={false}>
                ({quantity}) {orderItem.itemName}
              </ItemDetail>
            </RowContent>
          </ItemRow>
        </div>
      );
    });

    return (
      <Styled.OrderTaskWrapper>
        <Styled.OrderTaskTitle>Cancel Order</Styled.OrderTaskTitle>
        <Styled.OrderTaskDescription>{this.placeholderText}</Styled.OrderTaskDescription>

        {this.isSimplrRefundDetailsExist && (
          <CancelStep>
            <StepTitle>Following items have been already refunded.</StepTitle>
            {refundedItemsJSX}
          </CancelStep>
        )}

        {!this.hasShippedItems && !this.isOrderCancelled && this.hasRefundableItems && (
          <CancelStep>
            {!this.hasShippedItems && this.hasRefundableItems ? (
              <StepTitle>
                <Subtext>Step 1 - </Subtext> The whole order will be canceled, for partial cancels, use the RefundOrder
                for the items that customer want to cancel
              </StepTitle>
            ) : (
              <StepTitle>None of the items in this order are refundable.</StepTitle>
            )}

            {!this.hasShippedItems && (
              <ItemRow>
                <Checkbox type="checkbox" checked={this.isAllItemsSelected} onChange={() => this.handleSelectAll()} />
                <RowContent>
                  <Subtext>Select all</Subtext>
                </RowContent>
              </ItemRow>
            )}

            <Divider />

            {!this.hasShippedItems && refundableItemsJSX}

            <Divider />
          </CancelStep>
        )}

        {this.hasShippedItems && !this.isOrderCancelled && (
          <CancelStep>
            <StepTitle>Following items have been shipped.</StepTitle>

            {shippedItemsJSX}

            <Divider />
          </CancelStep>
        )}

        {!this.hasShippedItems && !this.isOrderCancelled && this.hasRefundableItems && (
          <CancelStep>
            <StepTitle>
              <Subtext>Step 2 - </Subtext>Select reason for cancelling (mandatory)
            </StepTitle>

            <RowContent>
              <RefundCommentTextarea
                name="reasonComment"
                value={this.state.reasonComment}
                onChange={this.handlerTextInputChange}
              />

              <FlexPlaceholder />

              <OrderSummaryBox>
                <OrderSummaryHeader>Refund Summary:</OrderSummaryHeader>
                <OrderSummaryInfo>
                  <RowContent>
                    <div>Subtotal</div>
                    <div>{this.priceFormat(parseFloat(this.subtotal).toFixed(2))}</div>
                  </RowContent>
                  <RowContent>
                    <div>Shipping</div>
                    <div>{this.priceFormat(parseFloat(this.shipping).toFixed(2))}</div>
                  </RowContent>
                  <RowContent>
                    <div>Tax</div>
                    <div>{this.priceFormat(parseFloat(this.tax).toFixed(2))}</div>
                  </RowContent>
                  <Divider />
                  <RowContent>
                    <OrderSubtotalInfo>Refund total</OrderSubtotalInfo>
                    <OrderSubtotalInfo>{this.priceFormat(parseFloat(this.totalRefund).toFixed(2))}</OrderSubtotalInfo>
                  </RowContent>
                </OrderSummaryInfo>
              </OrderSummaryBox>
            </RowContent>
          </CancelStep>
        )}

        <Styled.OrderTaskControls>
          <Button onClick={this.handleBackBtnClick}>BACK</Button>
          {!this.hasShippedItems && !this.isOrderCancelled && (
            <CancelOrderButton active={true} onClick={this.handleRefundBtnClick}>
              CANCEL ORDER
            </CancelOrderButton>
          )}
        </Styled.OrderTaskControls>
      </Styled.OrderTaskWrapper>
    );
  }

  render() {
    if (this.state.isCancelRequesting) {
      return <Loading label="Refund order..." />;
    }
    if (this.state.isCancelOrderItemsRequesting) {
      return <Loading label="Loading cancel information..." />;
    }

    return this.renderComponent();
  }
}

const mapStateToProps = (state) => {
  const selectedOrder = getSelectedOrderFromOrdersSearch(state);

  return {
    selectedOrder: selectedOrder,
    selectedTicket: extractSelectedTicketFromState(state),
    selectedInboxTab: extractSelectedInboxTab(state),
    selectedToolDomains: selectSelectedToolDomains(state),
    isSpecialist: isSpecialist(state),
    domain: selectedOrder.domain || null,
  };
};

export default connect(mapStateToProps, {
  setSelectedTask,
  addNoteToTicket,
  cancelSimplrOrder,
})(SimplrCancelOrder);
